import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_soustitre_1Texte, id_soustitre_1CouleurTexte, id_soustitre_1Opacite, id_soustitre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_card_1_icon_1Id, id_card_1_icon_1Alt, id_card_1_icon_1Opacite, id_card_1_icon_1Afficher, id_card_1_titre_1Texte, id_card_1_titre_1CouleurTexte, id_card_1_titre_1Opacite, id_card_1_titre_1Afficher, id_card_1_paragraphe_1Texte, id_card_1_paragraphe_1CouleurTexte, id_card_1_paragraphe_1Opacite, id_card_1_paragraphe_1Afficher, id_card_2_icon_1Id, id_card_2_icon_1Alt, id_card_2_icon_1Opacite, id_card_2_icon_1Afficher, id_card_2_titre_1Texte, id_card_2_titre_1CouleurTexte, id_card_2_titre_1Opacite, id_card_2_titre_1Afficher, id_card_2_paragraphe_1Texte, id_card_2_paragraphe_1CouleurTexte, id_card_2_paragraphe_1Opacite, id_card_2_paragraphe_1Afficher, id_card_3_icon_1Id, id_card_3_icon_1Alt, id_card_3_icon_1Opacite, id_card_3_icon_1Afficher, id_card_3_titre_1Texte, id_card_3_titre_1CouleurTexte, id_card_3_titre_1Opacite, id_card_3_titre_1Afficher, id_card_3_paragraphe_1Texte, id_card_3_paragraphe_1CouleurTexte, id_card_3_paragraphe_1Opacite, id_card_3_paragraphe_1Afficher, id_card_4_icon_1Id, id_card_4_icon_1Alt, id_card_4_icon_1Opacite, id_card_4_icon_1Afficher, id_card_4_titre_1Texte, id_card_4_titre_1CouleurTexte, id_card_4_titre_1Opacite, id_card_4_titre_1Afficher, id_card_4_paragraphe_1Texte, id_card_4_paragraphe_1CouleurTexte, id_card_4_paragraphe_1Opacite, id_card_4_paragraphe_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_card_1_icon_1ImageUrl, id_card_2_icon_1ImageUrl, id_card_3_icon_1ImageUrl, id_card_4_icon_1ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_card_1_icon_1ImageUrl: id_card_1_icon_1Id ? media.getMedia( id_card_1_icon_1Id )?.source_url : null,
            id_card_2_icon_1ImageUrl: id_card_2_icon_1Id ? media.getMedia( id_card_2_icon_1Id )?.source_url : null,
            id_card_3_icon_1ImageUrl: id_card_3_icon_1Id ? media.getMedia( id_card_3_icon_1Id )?.source_url : null,
            id_card_4_icon_1ImageUrl: id_card_4_icon_1Id ? media.getMedia( id_card_4_icon_1Id )?.source_url : null
        };
    }, [ blocImageFondId, id_card_1_icon_1Id, id_card_2_icon_1Id, id_card_3_icon_1Id, id_card_4_icon_1Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_soustitre_1Afficher}
                        onChange={(val) => setAttributes({ id_soustitre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_soustitre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_soustitre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_soustitre_1Opacite}
                        onChange={(val) => setAttributes({ id_soustitre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_1_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_1_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_2_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_2_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_3_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_3_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icon-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_4_icon_1Afficher}
                        onChange={(val) => setAttributes({ id_card_4_icon_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_4_icon_1Alt}
                            onChange={(val) => setAttributes({ id_card_4_icon_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_4_icon_1Opacite}
                        onChange={(val) => setAttributes({ id_card_4_icon_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_4_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_4_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_4_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_4_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_4_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_4_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_4_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_4_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_4_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_4_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_4_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_4_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                {/* id_titre_1 */}
                {id_titre_1Afficher && (
                    <RichText 
                        tagName="h1" 
                        className="id_titre_1 " 
                        value={id_titre_1Texte} 
                        onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                    />
                )}
                {/* end-id_titre_1 */}
                {/* id_soustitre_1 */}
                {id_soustitre_1Afficher && (
                    <RichText 
                        tagName="h2" 
                        className="id_soustitre_1 " 
                        value={id_soustitre_1Texte} 
                        onChange={(val) => setAttributes({ id_soustitre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_soustitre_1CouleurTexte, opacity: id_soustitre_1Opacite }} 
                    />
                )}
                {/* end-id_soustitre_1 */}
                {/* id_paragraphe_1 */}
                {id_paragraphe_1Afficher && (
                    <RichText 
                        tagName="p" 
                        className="id_paragraphe_1 " 
                        value={id_paragraphe_1Texte} 
                        onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                    />
                )}
                {/* end-id_paragraphe_1 */}
                <div className="row">
                    {/* id_card_1 */}
                    <div className="col-12 col-md-6 col-lg-3">
                        {/* id_card_1_icon_1 */}
                        {id_card_1_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_1_icon_1Id: media.id, id_card_1_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_1_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_1_icon_1ImageUrl ? (
                                            <img className="id_card_1_icon_1" src={id_card_1_icon_1ImageUrl} alt={id_card_1_icon_1Alt} style={{ opacity: id_card_1_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_1_icon_1 */}
                        {/* id_card_1_titre_1 */}
                        {id_card_1_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_1_titre_1 " 
                                value={id_card_1_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_titre_1CouleurTexte, opacity: id_card_1_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_titre_1 */}
                        {/* id_card_1_paragraphe_1 */}
                        {id_card_1_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_1_paragraphe_1 " 
                                value={id_card_1_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_paragraphe_1CouleurTexte, opacity: id_card_1_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_paragraphe_1 */}
                        {/* id_card_1_bouton_1 */}
                        <a id="id_card_1_bouton_1" href="attribut_id_card_1_bouton_1_lien" className="btn" role="button">
                            {/* id_card_1_bouton_1_texte */}
                            <span id="id_card_1_bouton_1_texte">
attribut_id_card_1_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_1_bouton_1_texte */}
                        </a>
                        {/* end-id_card_1_bouton_1 */}
                        {/* id_card_1_lien_surlignage_1 */}
                        <a href="attribut_id_card_1_lien_surlignage_1_lien" id="id_card_1_lien_surlignage_1">
                            {/* id_card_1_lien_surlignage_1_lien_1 */}
                            <span id="id_card_1_lien_surlignage_1_lien_1">
attribut_id_card_1_lien_surlignage_1_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_1_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_1 */}
                        {/* id_card_1_lien_surlignage_2 */}
                        <a href="attribut_id_card_1_lien_surlignage_2_lien" id="id_card_1_lien_surlignage_2">
                            {/* id_card_1_lien_surlignage_2_lien_1 */}
                            <span id="id_card_1_lien_surlignage_2_lien_1">
attribut_id_card_1_lien_surlignage_2_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_2_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_2 */}
                        {/* id_card_1_lien_surlignage_3 */}
                        <a href="attribut_id_card_1_lien_surlignage_3_lien" id="id_card_1_lien_surlignage_3">
                            {/* id_card_1_lien_surlignage_3_lien_1 */}
                            <span id="id_card_1_lien_surlignage_3_lien_1">
attribut_id_card_1_lien_surlignage_3_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_3_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_3 */}
                        {/* id_card_1_lien_surlignage_4 */}
                        <a href="attribut_id_card_1_lien_surlignage_4_lien" id="id_card_1_lien_surlignage_4">
                            {/* id_card_1_lien_surlignage_4_lien_1 */}
                            <span id="id_card_1_lien_surlignage_4_lien_1">
attribut_id_card_1_lien_surlignage_4_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_4_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_4 */}
                        {/* id_card_1_lien_surlignage_5 */}
                        <a href="attribut_id_card_1_lien_surlignage_5_lien" id="id_card_1_lien_surlignage_5">
                            {/* id_card_1_lien_surlignage_5_lien_1 */}
                            <span id="id_card_1_lien_surlignage_5_lien_1">
attribut_id_card_1_lien_surlignage_5_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_5_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_5 */}
                        {/* id_card_1_lien_surlignage_6 */}
                        <a href="attribut_id_card_1_lien_surlignage_6_lien" id="id_card_1_lien_surlignage_6">
                            {/* id_card_1_lien_surlignage_6_lien_1 */}
                            <span id="id_card_1_lien_surlignage_6_lien_1">
attribut_id_card_1_lien_surlignage_6_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_6_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_6 */}
                        {/* id_card_1_lien_surlignage_7 */}
                        <a href="attribut_id_card_1_lien_surlignage_7_lien" id="id_card_1_lien_surlignage_7">
                            {/* id_card_1_lien_surlignage_7_lien_1 */}
                            <span id="id_card_1_lien_surlignage_7_lien_1">
attribut_id_card_1_lien_surlignage_7_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_7_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_7 */}
                        {/* id_card_1_lien_surlignage_8 */}
                        <a href="attribut_id_card_1_lien_surlignage_8_lien" id="id_card_1_lien_surlignage_8">
                            {/* id_card_1_lien_surlignage_8_lien_1 */}
                            <span id="id_card_1_lien_surlignage_8_lien_1">
attribut_id_card_1_lien_surlignage_8_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_8_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_8 */}
                        {/* id_card_1_lien_surlignage_9 */}
                        <a href="attribut_id_card_1_lien_surlignage_9_lien" id="id_card_1_lien_surlignage_9">
                            {/* id_card_1_lien_surlignage_9_lien_1 */}
                            <span id="id_card_1_lien_surlignage_9_lien_1">
attribut_id_card_1_lien_surlignage_9_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_9_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_9 */}
                        {/* id_card_1_lien_surlignage_10 */}
                        <a href="attribut_id_card_1_lien_surlignage_10_lien" id="id_card_1_lien_surlignage_10">
                            {/* id_card_1_lien_surlignage_10_lien_1 */}
                            <span id="id_card_1_lien_surlignage_10_lien_1">
attribut_id_card_1_lien_surlignage_10_lien_1_texte
                            </span>
                            {/* end-id_card_1_lien_surlignage_10_lien_1 */}
                        </a>
                        {/* end-id_card_1_lien_surlignage_10 */}
                    </div>
                    {/* end-id_card_1 */}
                    {/* id_card_2 */}
                    <div className="col-12 col-md-6 col-lg-3">
                        {/* id_card_2_icon_1 */}
                        {id_card_2_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_2_icon_1Id: media.id, id_card_2_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_2_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_2_icon_1ImageUrl ? (
                                            <img className="id_card_2_icon_1" src={id_card_2_icon_1ImageUrl} alt={id_card_2_icon_1Alt} style={{ opacity: id_card_2_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_2_icon_1 */}
                        {/* id_card_2_titre_1 */}
                        {id_card_2_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_2_titre_1 " 
                                value={id_card_2_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_titre_1CouleurTexte, opacity: id_card_2_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_titre_1 */}
                        {/* id_card_2_paragraphe_1 */}
                        {id_card_2_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_2_paragraphe_1 " 
                                value={id_card_2_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_paragraphe_1CouleurTexte, opacity: id_card_2_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_paragraphe_1 */}
                        {/* id_card_2_bouton_1 */}
                        <a id="id_card_2_bouton_1" href="attribut_id_card_2_bouton_1_lien" className="btn" role="button">
                            {/* id_card_2_bouton_1_texte */}
                            <span id="id_card_2_bouton_1_texte">
attribut_id_card_2_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_2_bouton_1_texte */}
                        </a>
                        {/* end-id_card_2_bouton_1 */}
                        {/* id_card_2_lien_surlignage_1 */}
                        <a href="attribut_id_card_2_lien_surlignage_1_lien" id="id_card_2_lien_surlignage_1">
                            {/* id_card_2_lien_surlignage_1_lien_1 */}
                            <span id="id_card_2_lien_surlignage_1_lien_1">
attribut_id_card_2_lien_surlignage_1_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_1_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_1 */}
                        {/* id_card_2_lien_surlignage_2 */}
                        <a href="attribut_id_card_2_lien_surlignage_2_lien" id="id_card_2_lien_surlignage_2">
                            {/* id_card_2_lien_surlignage_2_lien_1 */}
                            <span id="id_card_2_lien_surlignage_2_lien_1">
attribut_id_card_2_lien_surlignage_2_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_2_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_2 */}
                        {/* id_card_2_lien_surlignage_3 */}
                        <a href="attribut_id_card_2_lien_surlignage_3_lien" id="id_card_2_lien_surlignage_3">
                            {/* id_card_2_lien_surlignage_3_lien_1 */}
                            <span id="id_card_2_lien_surlignage_3_lien_1">
attribut_id_card_2_lien_surlignage_3_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_3_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_3 */}
                        {/* id_card_2_lien_surlignage_4 */}
                        <a href="attribut_id_card_2_lien_surlignage_4_lien" id="id_card_2_lien_surlignage_4">
                            {/* id_card_2_lien_surlignage_4_lien_1 */}
                            <span id="id_card_2_lien_surlignage_4_lien_1">
attribut_id_card_2_lien_surlignage_4_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_4_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_4 */}
                        {/* id_card_2_lien_surlignage_5 */}
                        <a href="attribut_id_card_2_lien_surlignage_5_lien" id="id_card_2_lien_surlignage_5">
                            {/* id_card_2_lien_surlignage_5_lien_1 */}
                            <span id="id_card_2_lien_surlignage_5_lien_1">
attribut_id_card_2_lien_surlignage_5_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_5_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_5 */}
                        {/* id_card_2_lien_surlignage_6 */}
                        <a href="attribut_id_card_2_lien_surlignage_6_lien" id="id_card_2_lien_surlignage_6">
                            {/* id_card_2_lien_surlignage_6_lien_1 */}
                            <span id="id_card_2_lien_surlignage_6_lien_1">
attribut_id_card_2_lien_surlignage_6_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_6_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_6 */}
                        {/* id_card_2_lien_surlignage_7 */}
                        <a href="attribut_id_card_2_lien_surlignage_7_lien" id="id_card_2_lien_surlignage_7">
                            {/* id_card_2_lien_surlignage_7_lien_1 */}
                            <span id="id_card_2_lien_surlignage_7_lien_1">
attribut_id_card_2_lien_surlignage_7_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_7_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_7 */}
                        {/* id_card_2_lien_surlignage_8 */}
                        <a href="attribut_id_card_2_lien_surlignage_8_lien" id="id_card_2_lien_surlignage_8">
                            {/* id_card_2_lien_surlignage_8_lien_1 */}
                            <span id="id_card_2_lien_surlignage_8_lien_1">
attribut_id_card_2_lien_surlignage_8_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_8_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_8 */}
                        {/* id_card_2_lien_surlignage_9 */}
                        <a href="attribut_id_card_2_lien_surlignage_9_lien" id="id_card_2_lien_surlignage_9">
                            {/* id_card_2_lien_surlignage_9_lien_1 */}
                            <span id="id_card_2_lien_surlignage_9_lien_1">
attribut_id_card_2_lien_surlignage_9_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_9_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_9 */}
                        {/* id_card_2_lien_surlignage_10 */}
                        <a href="attribut_id_card_2_lien_surlignage_10_lien" id="id_card_2_lien_surlignage_10">
                            {/* id_card_2_lien_surlignage_10_lien_1 */}
                            <span id="id_card_2_lien_surlignage_10_lien_1">
attribut_id_card_2_lien_surlignage_10_lien_1_texte
                            </span>
                            {/* end-id_card_2_lien_surlignage_10_lien_1 */}
                        </a>
                        {/* end-id_card_2_lien_surlignage_10 */}
                    </div>
                    {/* end-id_card_2 */}
                    {/* id_card_3 */}
                    <div className="col-12 col-md-6 col-lg-3">
                        {/* id_card_3_icon_1 */}
                        {id_card_3_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_3_icon_1Id: media.id, id_card_3_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_3_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_3_icon_1ImageUrl ? (
                                            <img className="id_card_3_icon_1" src={id_card_3_icon_1ImageUrl} alt={id_card_3_icon_1Alt} style={{ opacity: id_card_3_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_3_icon_1 */}
                        {/* id_card_3_titre_1 */}
                        {id_card_3_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_3_titre_1 " 
                                value={id_card_3_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_titre_1CouleurTexte, opacity: id_card_3_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_titre_1 */}
                        {/* id_card_3_paragraphe_1 */}
                        {id_card_3_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_3_paragraphe_1 " 
                                value={id_card_3_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_paragraphe_1CouleurTexte, opacity: id_card_3_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_paragraphe_1 */}
                        {/* id_card_3_bouton_1 */}
                        <a id="id_card_3_bouton_1" href="attribut_id_card_3_bouton_1_lien" className="btn" role="button">
                            {/* id_card_3_bouton_1_texte */}
                            <span id="id_card_3_bouton_1_texte">
attribut_id_card_3_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_3_bouton_1_texte */}
                        </a>
                        {/* end-id_card_3_bouton_1 */}
                        {/* id_card_3_lien_surlignage_1 */}
                        <a href="attribut_id_card_3_lien_surlignage_1_lien" id="id_card_3_lien_surlignage_1">
                            {/* id_card_3_lien_surlignage_1_lien_1 */}
                            <span id="id_card_3_lien_surlignage_1_lien_1">
attribut_id_card_3_lien_surlignage_1_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_1_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_1 */}
                        {/* id_card_3_lien_surlignage_2 */}
                        <a href="attribut_id_card_3_lien_surlignage_2_lien" id="id_card_3_lien_surlignage_2">
                            {/* id_card_3_lien_surlignage_2_lien_1 */}
                            <span id="id_card_3_lien_surlignage_2_lien_1">
attribut_id_card_3_lien_surlignage_2_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_2_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_2 */}
                        {/* id_card_3_lien_surlignage_3 */}
                        <a href="attribut_id_card_3_lien_surlignage_3_lien" id="id_card_3_lien_surlignage_3">
                            {/* id_card_3_lien_surlignage_3_lien_1 */}
                            <span id="id_card_3_lien_surlignage_3_lien_1">
attribut_id_card_3_lien_surlignage_3_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_3_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_3 */}
                        {/* id_card_3_lien_surlignage_4 */}
                        <a href="attribut_id_card_3_lien_surlignage_4_lien" id="id_card_3_lien_surlignage_4">
                            {/* id_card_3_lien_surlignage_4_lien_1 */}
                            <span id="id_card_3_lien_surlignage_4_lien_1">
attribut_id_card_3_lien_surlignage_4_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_4_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_4 */}
                        {/* id_card_3_lien_surlignage_5 */}
                        <a href="attribut_id_card_3_lien_surlignage_5_lien" id="id_card_3_lien_surlignage_5">
                            {/* id_card_3_lien_surlignage_5_lien_1 */}
                            <span id="id_card_3_lien_surlignage_5_lien_1">
attribut_id_card_3_lien_surlignage_5_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_5_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_5 */}
                        {/* id_card_3_lien_surlignage_6 */}
                        <a href="attribut_id_card_3_lien_surlignage_6_lien" id="id_card_3_lien_surlignage_6">
                            {/* id_card_3_lien_surlignage_6_lien_1 */}
                            <span id="id_card_3_lien_surlignage_6_lien_1">
attribut_id_card_3_lien_surlignage_6_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_6_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_6 */}
                        {/* id_card_3_lien_surlignage_7 */}
                        <a href="attribut_id_card_3_lien_surlignage_7_lien" id="id_card_3_lien_surlignage_7">
                            {/* id_card_3_lien_surlignage_7_lien_1 */}
                            <span id="id_card_3_lien_surlignage_7_lien_1">
attribut_id_card_3_lien_surlignage_7_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_7_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_7 */}
                        {/* id_card_3_lien_surlignage_8 */}
                        <a href="attribut_id_card_3_lien_surlignage_8_lien" id="id_card_3_lien_surlignage_8">
                            {/* id_card_3_lien_surlignage_8_lien_1 */}
                            <span id="id_card_3_lien_surlignage_8_lien_1">
attribut_id_card_3_lien_surlignage_8_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_8_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_8 */}
                        {/* id_card_3_lien_surlignage_9 */}
                        <a href="attribut_id_card_3_lien_surlignage_9_lien" id="id_card_3_lien_surlignage_9">
                            {/* id_card_3_lien_surlignage_9_lien_1 */}
                            <span id="id_card_3_lien_surlignage_9_lien_1">
attribut_id_card_3_lien_surlignage_9_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_9_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_9 */}
                        {/* id_card_3_lien_surlignage_10 */}
                        <a href="attribut_id_card_3_lien_surlignage_10_lien" id="id_card_3_lien_surlignage_10">
                            {/* id_card_3_lien_surlignage_10_lien_1 */}
                            <span id="id_card_3_lien_surlignage_10_lien_1">
attribut_id_card_3_lien_surlignage_10_lien_1_texte
                            </span>
                            {/* end-id_card_3_lien_surlignage_10_lien_1 */}
                        </a>
                        {/* end-id_card_3_lien_surlignage_10 */}
                    </div>
                    {/* end-id_card_3 */}
                    {/* id_card_4 */}
                    <div className="col-12 col-md-6 col-lg-3">
                        {/* id_card_4_icon_1 */}
                        {id_card_4_icon_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_card_4_icon_1Id: media.id, id_card_4_icon_1Alt: media.alt })}
                                type="image"
                                value={id_card_4_icon_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_card_4_icon_1ImageUrl ? (
                                            <img className="id_card_4_icon_1" src={id_card_4_icon_1ImageUrl} alt={id_card_4_icon_1Alt} style={{ opacity: id_card_4_icon_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_card_4_icon_1 */}
                        {/* id_card_4_titre_1 */}
                        {id_card_4_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_4_titre_1 " 
                                value={id_card_4_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_4_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_4_titre_1CouleurTexte, opacity: id_card_4_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_4_titre_1 */}
                        {/* id_card_4_paragraphe_1 */}
                        {id_card_4_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_4_paragraphe_1 " 
                                value={id_card_4_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_4_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_4_paragraphe_1CouleurTexte, opacity: id_card_4_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_4_paragraphe_1 */}
                        {/* id_card_4_bouton_1 */}
                        <a id="id_card_4_bouton_1" href="attribut_id_card_4_bouton_1_lien" className="btn" role="button">
                            {/* id_card_4_bouton_1_texte */}
                            <span id="id_card_4_bouton_1_texte">
attribut_id_card_4_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_4_bouton_1_texte */}
                        </a>
                        {/* end-id_card_4_bouton_1 */}
                        {/* id_card_4_lien_surlignage_1 */}
                        <a href="attribut_id_card_4_lien_surlignage_1_lien" id="id_card_4_lien_surlignage_1">
                            {/* id_card_4_lien_surlignage_1_lien_1 */}
                            <span id="id_card_4_lien_surlignage_1_lien_1">
attribut_id_card_4_lien_surlignage_1_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_1_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_1 */}
                        {/* id_card_4_lien_surlignage_2 */}
                        <a href="attribut_id_card_4_lien_surlignage_2_lien" id="id_card_4_lien_surlignage_2">
                            {/* id_card_4_lien_surlignage_2_lien_1 */}
                            <span id="id_card_4_lien_surlignage_2_lien_1">
attribut_id_card_4_lien_surlignage_2_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_2_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_2 */}
                        {/* id_card_4_lien_surlignage_3 */}
                        <a href="attribut_id_card_4_lien_surlignage_3_lien" id="id_card_4_lien_surlignage_3">
                            {/* id_card_4_lien_surlignage_3_lien_1 */}
                            <span id="id_card_4_lien_surlignage_3_lien_1">
attribut_id_card_4_lien_surlignage_3_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_3_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_3 */}
                        {/* id_card_4_lien_surlignage_4 */}
                        <a href="attribut_id_card_4_lien_surlignage_4_lien" id="id_card_4_lien_surlignage_4">
                            {/* id_card_4_lien_surlignage_4_lien_1 */}
                            <span id="id_card_4_lien_surlignage_4_lien_1">
attribut_id_card_4_lien_surlignage_4_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_4_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_4 */}
                        {/* id_card_4_lien_surlignage_5 */}
                        <a href="attribut_id_card_4_lien_surlignage_5_lien" id="id_card_4_lien_surlignage_5">
                            {/* id_card_4_lien_surlignage_5_lien_1 */}
                            <span id="id_card_4_lien_surlignage_5_lien_1">
attribut_id_card_4_lien_surlignage_5_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_5_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_5 */}
                        {/* id_card_4_lien_surlignage_6 */}
                        <a href="attribut_id_card_4_lien_surlignage_6_lien" id="id_card_4_lien_surlignage_6">
                            {/* id_card_4_lien_surlignage_6_lien_1 */}
                            <span id="id_card_4_lien_surlignage_6_lien_1">
attribut_id_card_4_lien_surlignage_6_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_6_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_6 */}
                        {/* id_card_4_lien_surlignage_7 */}
                        <a href="attribut_id_card_4_lien_surlignage_7_lien" id="id_card_4_lien_surlignage_7">
                            {/* id_card_4_lien_surlignage_7_lien_1 */}
                            <span id="id_card_4_lien_surlignage_7_lien_1">
attribut_id_card_4_lien_surlignage_7_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_7_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_7 */}
                        {/* id_card_4_lien_surlignage_8 */}
                        <a href="attribut_id_card_4_lien_surlignage_8_lien" id="id_card_4_lien_surlignage_8">
                            {/* id_card_4_lien_surlignage_8_lien_1 */}
                            <span id="id_card_4_lien_surlignage_8_lien_1">
attribut_id_card_4_lien_surlignage_8_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_8_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_8 */}
                        {/* id_card_4_lien_surlignage_9 */}
                        <a href="attribut_id_card_4_lien_surlignage_9_lien" id="id_card_4_lien_surlignage_9">
                            {/* id_card_4_lien_surlignage_9_lien_1 */}
                            <span id="id_card_4_lien_surlignage_9_lien_1">
attribut_id_card_4_lien_surlignage_9_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_9_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_9 */}
                        {/* id_card_4_lien_surlignage_10 */}
                        <a href="attribut_id_card_4_lien_surlignage_10_lien" id="id_card_4_lien_surlignage_10">
                            {/* id_card_4_lien_surlignage_10_lien_1 */}
                            <span id="id_card_4_lien_surlignage_10_lien_1">
attribut_id_card_4_lien_surlignage_10_lien_1_texte
                            </span>
                            {/* end-id_card_4_lien_surlignage_10_lien_1 */}
                        </a>
                        {/* end-id_card_4_lien_surlignage_10 */}
                    </div>
                    {/* end-id_card_4 */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}